import React from 'react'

export default function CompletionPanel({ totalScore, onComplete }) {
  return (
    <div className="completion-panel">
      <div className="completion-icon">
        🏆
      </div>
      <h3 className="completion-title">Chúc mừng!</h3>
      <p className="completion-message">
        Bạn đã đạt được mục tiêu!<br />
        Tổng điểm: <span className="completion-score">{totalScore}</span>
      </p>
      <button
        type="button"
        className="btn btn-success btn-lg completion-button"
        onClick={onComplete}
        data-testid="complete-button"
      >
        ✓ Hoàn thành
      </button>
    </div>
  )
}
